import rules from "../../../utils/rules";
import apiService from "../../../api/api.service";
export default {
  name: "forgot-password",
  data() {
    return {
      rules: rules,
      userEmail: null,
      loading: false,
      valid:true,
    };
  },
  methods: {
    backToLogin() {
      this.$router.push("/signin");
    },
    async sendEmail() {
      if (this.$refs.forgotPasswordForm.validate()) {
        let userId = this.userEmail;
        this.loading = true;
        let payload = {
          userEmail: userId
        };
        try {
          let response = await apiService.SendRecoveryEmail(payload);
          this.loading = false;
          if (response && response.data && response.data.isTokenGenerated) {
            this.$toast.success(
              "An email has been sent to you with a link to change your Password. Please follow the instructions in the email."
            );
            this.backToLogin();
          } else {
            this.$toast.error(response.systemMessage);
          }
        } catch (error) {
          this.loading = false;
          this.$toast.error("Unable to send Email" + error);
        }
      }
    }
  }
};
